import { URLDATA } from "./Config";
import store from "./Redux/Store";
let controller = new AbortController()
let signal = controller.signal
// signal.addEventListener("abort", () => {
//   console.log("aborted!")
// })
export const fetchMethod = (Query, Variables) => {
  if (signal.aborted) {
    controller = new AbortController();
    signal = controller.signal;
  }
  // console.log(signal,"#####");

  store.dispatch({ type: "TimeDelay", seconds: 1500 });
  return fetch(URLDATA.url, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({
      query: Query,
      variables: Variables,
    }),
    headers: {
      "Content-type": "application/json",
      access_token: localStorage.getItem("token"), // read fresh — module-level const was null before login
    },
    signal:signal
  });
};

export const abortFetching=() =>{
  // console.log('Now aborting',controller);
  // // Abort.
  // debugger
 controller.abort()
 return controller
}

export const debounce = (debounceTimer, func, delay) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
  return debounceTimer;
};

export const formatDate = (date, format) => {
  if (date !== null && date !== undefined) {
    let date1 = new Date(date);
    let dd = date1.getDate();
    let mm = date1.getMonth() + 1;
    let yyyy = date1.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    switch (format) {
      case "YYYY-MM-DD":
        date1 = yyyy + "-" + mm + "-" + dd;
        break;
      default:
        date1 = mm + "/" + dd + "/" + yyyy;
    }
    return date1;
    // return (date1 = mm + "/" + dd + "/" + yyyy);
  }

  return;
};
